module.exports = __webpack_public_path__ + "Worker.b2344b291dc1887fa87ca3c6f71d437b.hashedasset.svg";